import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";

interface CodeProps extends HTMLAttributes<HTMLElement>, CommonComponentProps {}

export function Code({ children, className, ...rest }: CodeProps) {
  return (
    <code
      className={cx(
        "relative bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold",
        className
      )}
      {...rest}
    >
      {children}
    </code>
  );
}
